import gql from 'graphql-tag';

export const CompanyBadgeListQuery = gql`
	query CompanyBadgeListQuery(
		$first: Int,
		$cursor: String,
		$filter: CompanyBadgeFilterInput
	) {
		entities: companyBadges(first: $first, after: $cursor, filter: $filter) {
			edges {
				node {
					id
					localId
					name
				}
			}
			total
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
		}

	}
`;


